import { Component, input } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { CarouselItemStyle, TutoStepContent } from '@shared/models';
import { SafePipe, VariableReplacementPipe } from '@shared/pipes';

@Component({
  selector: 'b2c-variant6',
  styleUrl: './variant6.component.scss',
  templateUrl: './variant6.component.html',
  imports: [SafePipe, VariableReplacementPipe],
})
export class Variant6Component extends BaseComponent {
  itemStyle = input.required<CarouselItemStyle>();
  stepContent = input.required<TutoStepContent>();

  public maxSelectedChallenges: number = this.environment.maxSelectedChallenges;
}
